import { createStore } from "vuex";

export default createStore({
  state: {
    passcode: "",
  },
  getters: {},
  mutations: {
    setPasscode(state: any, passcode: string) {
      state.passcode = passcode;
    },
  },
  actions: {
    savePasscode({ commit }: { commit: any }, passcode: string) {
      commit("setPasscode", passcode);
    },
  },
  modules: {},
});
